import { Pipe, PipeTransform } from '@angular/core';
import { DataService } from '../data.service';
import { environment } from 'src/environments/environment';
import { DomSanitizer, SafeResourceUrl, SafeUrl } from '@angular/platform-browser';

@Pipe({
  name: 'cms'
})
export class CmsPipe implements PipeTransform {
  constructor(public d: DataService, private sanitizer: DomSanitizer) { }
  transform(url): any {
    return this.d.cms(url);
  }

}
